import { handleAge } from '../../../utils/handleDOB';
import { convertDateToUIFormat } from '../../../utils/converters/dateConverters';

export default ({ gender, dob }, genderList, formatMessage) => {
  const params = [];
  if (gender && genderList) {
    const genderOption = genderList.find(item => item.value === gender);
    if (genderOption) params.push(genderOption.label);
  }
  if (dob) {
    const dobAPIFormat = convertDateToUIFormat(dob, formatMessage);
    params.push(handleAge(dobAPIFormat, formatMessage));
  }
  return params.join(', ');
};



// WEBPACK FOOTER //
// ./src/components/Surveys/utils/getComplementary.js